import { baseSecurityConfig } from './configBase';

export const pldSecurityConfig = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN_PLD,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID_PLD,
  authorizationParams: {
    ...baseSecurityConfig,
    redirect_uri: window.location.origin,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  },

  logout_uri: `${window.location.origin}/#/pld-login`,
};
